export function initAnimations() {
  // Skip animations if in edit mode
  if (document.querySelector(".edit-mode")) {
    document.body.classList.add("no-animation");
    return;
  }

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.animation = entry.target.dataset.animate;
          } else {
            entry.target.style.animation = "none";
          }
        });
      },
      {
        rootMargin: "500px 0px -40px 0px"
      }
    );

    const animate = document.querySelectorAll("[data-animate]");
    animate.forEach(el => observer.observe(el));
  } else {
    document.body.classList.add("no-animation");
  }
}
